// extracted by mini-css-extract-plugin
export default {"logoSize":"ComingSoon_logoSize__bZC-T","infoSize":"ComingSoon_infoSize__3BDrK"};